import * as React from 'react';

const ChevronDownIcon = ({
  height = '24px',
  width = '24px',
  ...props
}: React.SVGProps<SVGSVGElement> & { secondaryColor?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    focusable="false"
    aria-hidden="true"
    {...props}
    fill="none"
  >
    <path
      d="M6 9.00049L12 15.0005L18 9.00049"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronDownIcon;
